export default "__VITE_ASSET__CAUsrmBe__"